<template>
  <Layout>
    <div class="col-1">
      <RouterLink v-if="root === 'catalogs'" to="/catalogs">
        <h4 class="font-size-14 pt-2">
          <i class="mdi mdi-arrow-left color"></i> Retour
        </h4>
      </RouterLink>
      <RouterLink v-else-if="root === 'dashboard'" to="/">
        <h4 class="font-size-14 pt-2">
          <i class="mdi mdi-arrow-left color"></i> Retour
        </h4>
      </RouterLink>
      <RouterLink v-else-if="root === 'folders'" to="/folders">
        <h4 class="font-size-14 pt-2">
          <i class="mdi mdi-arrow-left color"></i> Retour
        </h4>
      </RouterLink>
      <RouterLink v-else :to="'/proposals/' + root">
        <h4 class="font-size-14 pt-2" v-if="root">
          <i class="mdi mdi-arrow-left color"></i> Retour
        </h4>
      </RouterLink>
    </div>
    <div class="row mb-3 col-12" v-if="folder">
      <div class="col-6 d-flex" v-if="folder.s_date_fin_fibourse">
        <h4 class="font-size-14 pt-2 col-7" v-if="folder.note && folder.id">
          {{ demandTypeStatus(folder.s_type_bien) }} - {{ useStatus(folder.s_usage_bien) }}</h4>
        <h6 class="ml-5 positionner col-5"
          v-if="folder && folder.s_date_fin_fibourse && dateCompare(dateFormat(folder.s_date_fin_fibourse)) > 0">
          {{ dateCompare(dateFormat(folder.s_date_fin_fibourse)) }} jour(s) restant(s) pour se positionner</h6>
        <h6 class="ml-5 positionner col-6 text-danger" v-else>
          Vous ne pouvez plus vous positionner (Date limite dépassée)</h6>
      </div>
      <div class="col-6 d-flex" v-else-if="loadingDetails">
        <h6 class="ml-5 positionner col-6 ">
          <b-spinner variant="success" small></b-spinner>
        </h6>
      </div>
      <div class="col-6 mt-n1">
        <div class="d-flex justify-content-end align-items-center">
          <div class="d-flex style-rating col-3">
            <span class="invisible">{{ note }}</span>
            <b-form-rating v-model="value" size="lg" color="#EBB13F" no-border readonly></b-form-rating>
          </div>
          
          <a href="#" class="btn btn-md ml-2 mx-2" :class="favoris ? 'btn-outline-secondary' : 'btn-outline-danger'"
            @click="addToFavoris()">
            <i class="fas fa-star me-1"></i>
            <span v-html="favoris ? 'Retirer des favoris' : 'Ajouter aux favoris'"></span>
          </a>
          <a :href="'/folders/' + folder.id + '/proposal'" class="btn btn-md ml-2 btn-primary"
            :class="(!folder.id || !nowDate) ? 'disabled' : ''">
            Se positionner
          </a>
          <a  class="btn btn-md ml-6 btn-secondary" @click="openModal" v-if="isManager">
            Affecter le dossier
          </a>
        </div>
      </div>
    </div>

    <div class="box-size checkout-tabs">
      <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-xl-2 col-sm-3">
        <b-tab active>
          <template v-slot:title>
            <i class="fas fa-info-circle d-block  check-nav-icon mt-3 mb-1"></i>
            <p class="fw-bold mb-3">Informations</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane fade show active">
                  <h4 class="card-title mb-5">Informations</h4>
                  <div class="table-responsive px-2">
                    <table class="table table-nowrap">
                      <tbody>
                        <tr>
                          <th scope="row">Type de bien :</th>
                          <td v-if="folder.s_type_bien">{{ demandTypeStatus(folder.s_type_bien) }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Modalité d’achat :</th>
                          <td v-if="folder.s_modalite_achat">
                            {{ purshaseMethodStatus(folder.s_modalite_achat) }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Mode d’achat :</th>
                          <td v-if="folder.s_mode_achat">
                            {{ modeOfPurshaseStatus(folder.s_mode_achat) }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Usage du bien :</th>
                          <td v-if="folder.s_usage_bien">{{ useStatus(folder.s_usage_bien) }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Date de création :</th>
                          <td v-if="folder.createdAt">{{ formatDate(folder.createdAt) }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">
                            Prix de vente à financer :
                          </th>
                          <td v-if="folder.s_montant_global">
                            {{ folder.s_montant_global | truncateMontant() }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Dont prix terrain :</th>
                          <td v-if="folder.s_acquisition">
                            {{ folder.s_acquisition | truncateMontant() }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Dont prix travaux :</th>
                          <td v-if="folder.s_montant_travaux">{{ folder.s_montant_travaux | truncateMontant() }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </b-card-text>
        </b-tab>
        <b-tab>
        <template v-slot:title>
            <i class="bx bxs-user d-block check-nav-icon mt-3 mb-1"></i>
            <p class="fw-bold mb-3">Courtier</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">Courtier</h4>
                  <div class="table-responsive px-2">
                    <table class="table table-nowrap">
                      <tbody>
                        <tr v-if="!folder.quote_details">
                          <th scope="row">Nom :</th>
                          <td v-if="folder.owner">{{ folder.owner.firstName }} {{ folder.owner.lastName }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr v-if="!folder.quote_details">
                          <th scope="row">Adresse e-mail :</th>
                          <td v-if="folder.owner">{{ folder.owner.email }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Téléphone :</th>
                          <td v-if="folder.owner.phone">
                            {{ folder.owner.phone }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Société :</th>
                          <td v-if="folder.owner.company">
                            {{ folder.owner.company }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
  <td>
    <div class="d-flex justify-content-start gap-5"> <!-- Conteneur parent avec Flexbox -->
      <!-- Premier fichier -->
      <div>
        <div class="float-end" v-if="folder.owner.legal_file_1">
          <a @click="downloadFile(folder.owner.legal_file_1)">
            <i class="bx bx-cloud-download icon-hover"></i>
          </a>
        </div>
        <div class="float-end" v-else>
          <a @click="alert()">
            <i class="bx bx-cloud-download icon-hover"></i>
          </a>
        </div>
        <div class="avatar-xs me-3 mb-3">
          <div class="avatar-title bg-transparent rounded">
            <i class="bx bxs-folder text-warning"></i>
          </div>
        </div>
        <div class="d-flex">
          <div class="overflow-hidden me-auto">
            <h5 class="font-size-14 text-truncate mb-1">
              <a href="javascript: void(0);" class="text-body">Fichier</a>
            </h5>
            <p class="text-muted-color text-truncate mb-0" v-if="folder.owner.legal_file_1">1 Files</p>
            <p class="text-muted-color text-truncate mb-0" v-else>0 Files</p>
          </div>
          <div class="align-self-end ms-2">
            <p class="text-muted-color mb-0" v-if="folder.owner.legal_file_2">{{ folder.owner.legal_file_1.fileSize }}KB</p>
            <p class="text-muted-color mb-0" v-else>0KB</p>
          </div>
        </div>
      </div>
      <!-- Répète le même bloc pour les deux autres fichiers -->
      <!-- Deuxième fichier -->
      <div>
        <div class="float-end" v-if="folder.owner.legal_file_2">
          <a @click="downloadFile(folder.owner.legal_file_2)">
            <i class="bx bx-cloud-download icon-hover"></i>
          </a>
        </div>
        <div class="float-end" v-else>
          <a @click="alert()">
            <i class="bx bx-cloud-download icon-hover"></i>
          </a>
        </div>
        <div class="avatar-xs me-3 mb-3">
          <div class="avatar-title bg-transparent rounded">
            <i class="bx bxs-folder text-warning"></i>
          </div>
        </div>
        <div class="d-flex">
          <div class="overflow-hidden me-auto">
            <h5 class="font-size-14 text-truncate mb-1">
              <a href="javascript: void(0);" class="text-body">Fichier</a>
            </h5>
            <p class="text-muted-color text-truncate mb-0" v-if="folder.owner.legal_file_2">1 Files</p>
            <p class="text-muted-color text-truncate mb-0" v-else>0 Files</p>
          </div>
          <div class="align-self-end ms-2">
            <p class="text-muted-color mb-0" v-if="folder.owner.legal_file_2">{{ folder.owner.legal_file_2.fileSize }}KB</p>
            <p class="text-muted-color mb-0" v-else>0KB</p>
          </div>
        </div>
      </div>
      <!-- Troisième fichier -->
      <div>
        <div class="float-end" v-if="folder.owner.legal_file_3">
          <a @click="downloadFile(folder.owner.legal_file_3)">
            <i class="bx bx-cloud-download icon-hover"></i>
          </a>
        </div>
        <div class="float-end" v-else>
          <a @click="alert()">
            <i class="bx bx-cloud-download icon-hover"></i>
          </a>
        </div>
        <div class="avatar-xs me-3 mb-3">
          <div class="avatar-title bg-transparent rounded">
            <i class="bx bxs-folder text-warning"></i>
          </div>
        </div>
        <div class="d-flex">
          <div class="overflow-hidden me-auto">
            <h5 class="font-size-14 text-truncate mb-1">
              <a href="javascript: void(0);" class="text-body">Fichier</a>
            </h5>
            <p class="text-muted-color text-truncate mb-0" v-if="folder.owner.legal_file_3">1 Files</p>
            <p class="text-muted-color text-truncate mb-0" v-else>0 Files</p>
          </div>
          <div class="align-self-end ms-2">
            <p class="text-muted-color mb-0" v-if="folder.owner.legal_file_3">{{ folder.owner.legal_file_3.fileSize }}KB</p>
            <p class="text-muted-color mb-0" v-else>0KB</p>
          </div>
        </div>      </div>
    </div>
  </td>
</tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
      </b-tab>
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-user d-block check-nav-icon mt-3 mb-1"></i>
            <p class="fw-bold mb-3">Demandeur</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">Demandeur</h4>
                  <div class="table-responsive px-2">
                    <table class="table table-nowrap">
                      <tbody>
                        <tr v-if="!folder.quote_details">
                          <th scope="row">Nom :</th>
                          <td v-if="folder.s_customer_name">{{ folder.s_customer_name }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr v-if="!folder.quote_details">
                          <th scope="row">Adresse e-mail :</th>
                          <td v-if="folder.email">{{ folder.email }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Lieux du dossier :</th>
                          <!-- <td v-if="!loadingDetails && folder.customerUser.city">
                            {{
                              (folder.customerUser.country.toUpperCase() === "FR") ? 'France' : folder.customerUser.country
                            }}
                            - {{ folder.customerUser.city }}
                          </td> -->
                          <td v-if="!loadingDetails && folder.s_ville">
                            {{
                              folder.s_codepostal
                            }}
                            - {{ folder.s_ville }}
                          </td>
                          <td v-else-if="!loadingDetails && folder.customerUser.city">
                            {{
                              (folder.customerUser.country.toUpperCase() === "FR") ? 'France' : folder.customerUser.country
                            }}
                            - {{ folder.customerUser.city }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Situation professionnelle :</th>
                          <td v-if="folder.s_situation_pro">
                            {{ professionalSituationStatus(folder.s_situation_pro) }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Revenus nets imposables :</th>
                          <td v-if="folder.s_montant_impot">{{ folder.s_montant_impot | truncateMontant() }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Mensualité des crédits :</th>
                          <td v-if="folder.s_montant_credit">{{ folder.s_montant_credit | truncateMontant() }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Montant de l’apport :</th>
                          <td v-if="folder.s_montant_apport">{{ folder.s_montant_apport | truncateMontant() }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Durée du crédit souhaitée :</th>
                          <td v-if="folder.s_duree_credit_souhait">
                            {{ creditsStatus(folder.s_duree_credit_souhait) }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Mensualité maximum :</th>
                          <td v-if="folder.s_montant_mens_max">{{ folder.s_montant_mens_max | truncateMontant() }}
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <i class="bx bx-stats d-block check-nav-icon mt-3 mb-1"></i>
            <p class="fw-bold mb-3">Analyse</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">Analyse</h4>
                  <div class="table-responsive px-2">
                    <table class="table table-nowrap">
                      <tbody>
                        <tr>
                          <th scope="row">Votre courtier :</th>
                          <td v-if="folder.owner">{{ folder.owner.firstName }} {{ folder.owner.lastName }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr>
                          <th scope="row">Société :</th>
                          <td v-if="folder.company">{{ folder.company }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr class="style-text">
                          <th scope="row">Analyse:</th>
                          <td v-if="folder.s_analyse_fibourse">{{ folder.s_analyse_fibourse }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-dashboard d-block check-nav-icon mt-3 mb-1"></i>
            <p class="fw-bold mb-3">Projet</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">Projet</h4>
                  <div class="table-responsive px-2">
                    <table class="table table-nowrap">
                      <tbody>
                        <tr>
                          <th scope="row">Déscription :</th>
                          <td v-if="folder.note">{{ folder.note }}</td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr class="style-text">
                          <th scope="row">Vidéo :</th>
                          <td v-if="folder.s_url_project_media">
                            <video controls width="500px" height="400px">
                              <source type="video/webm"
                                :src="'data:video/webm;base64,' + folder.s_url_project_media.content">
                              <source type="video/mp4" :src="'data:video/mp4;base64,' + folder.s_url_project_media.content">
                            </video>
                          </td>
                          <td v-else-if="loadingDetails">
                            <b-spinner variant="success" small></b-spinner>
                          </td>
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-folder-open d-block check-nav-icon mt-3 mb-1"></i>
            <p class="fw-bold mb-3">Documents</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">Documents</h4>
                  <div class="col-xl-4 col-sm-6">
                    <div class="card shadow-none border">
                      <div class="card-body p-3">
                        <div>
                          <div class="float-end " v-if="folder.s_carcasse">
                            <a @click="addDownloadHistory(folder.s_carcasse,folder.id)"><i
                                class="bx bx-cloud-download  icon-hover"></i></a>
                          </div>
                          <div class="float-end " v-else>
                            <a @click="alert()"><i class="bx bx-cloud-download  icon-hover"></i></a>
                          </div>
                          <div class="avatar-xs me-3 mb-3">
                            <div class="avatar-title bg-transparent rounded">
                              <i class="bx bxs-folder  text-warning"></i>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="overflow-hidden me-auto">
                              <h5 class="font-size-14 text-truncate mb-1">
                                <a href="javascript: void(0);" class="text-body">Carcasse</a>
                              </h5>
                              <p class="text-muted-color text-truncate mb-0" v-if="folder.s_carcasse">
                                1 Files
                              </p>
                              <p class="text-muted-color text-truncate mb-0" v-else>
                                0 Files
                              </p>
                            </div>
                            <div class="align-self-end ms-2">
                              <p class="text-muted-color mb-0" v-if="folder.s_carcasse">
                                {{ folder.s_carcasse.fileSize }}KB</p>
                              <p class="text-muted-color mb-0" v-else>0KB</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 col-sm-6">
                    <div class="card shadow-none border">
                      <div class="card-body p-3">
                        <div>
                          <div class="float-end " v-if="folder.mandat">
                            <a @click="downloadFile(folder.mandat)"><i
                                class="bx bx-cloud-download  icon-hover"></i></a>
                          </div>
                          <div class="float-end " v-else>
                            <a @click="alert()"><i class="bx bx-cloud-download  icon-hover"></i></a>
                          </div>
                          <div class="avatar-xs me-3 mb-3">
                            <div class="avatar-title bg-transparent rounded">
                              <i class="bx bxs-folder  text-warning"></i>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="overflow-hidden me-auto">
                              <h5 class="font-size-14 text-truncate mb-1">
                                <a href="javascript: void(0);" class="text-body">Mandat</a>
                              </h5>
                              <p class="text-muted-color text-truncate mb-0" v-if="folder.mandat">
                                1 Files
                              </p>
                              <p class="text-muted-color text-truncate mb-0" v-else>
                                0 Files
                              </p>
                            </div>
                            <div class="align-self-end ms-2">
                              <p class="text-muted-color mb-0" v-if="folder.mandat">
                                {{ folder.mandat.fileSize }}KB</p>
                              <p class="text-muted-color mb-0" v-else>0KB</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 col-sm-6">
                    <div class="card shadow-none border">
                      <div class="card-body p-3">
                        <div>
                          <div class="float-end " v-if="folder.s_url_fidoc">
                            <a :href="folder.s_url_fidoc" target="_blank"><i
                                class="bx bx-cloud-download  icon-hover"></i></a>
                          </div>
                          <div class="float-end " v-else>
                            <a @click="alert()"><i class="bx bx-cloud-download  icon-hover"></i></a>
                          </div>
                          <div class="avatar-xs me-3 mb-3">
                            <div class="avatar-title bg-transparent rounded">
                              <i class="bx bxs-folder  text-warning"></i>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="overflow-hidden me-auto">
                              <h5 class="font-size-14 text-truncate mb-1">
                                <a href="javascript: void(0);" class="text-body">Dossier complet</a>
                              </h5>
                              <p class="text-muted-color text-truncate mb-0" v-if="folder.s_url_fidoc">
                                1 Files
                              </p>
                              <p class="text-muted-color text-truncate mb-0" v-else>
                                0 Files
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab :active="!isNaN(root)">
          <template v-slot:title>
            <i class="bx bx-history d-block check-nav-icon mt-3 mb-1"></i>
            <p class="fw-bold mb-3">Historiques Proposition</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">Historiques des propositions</h4>
                  <div class="col-xl-12 col-sm-12">
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="card p-1">
                          <h4 class="card-title p-2">Mes 5 dernières propositions</h4>
                          <div class="table-responsive shadow-none">
                            <b-table class="table mb-0 table-responsive" hover responsive="sm" :items="proposals"
                              :fields="headerTable" :per-page="5" :current-page="currentPageMy"
                              v-if="!proposalsByConnect">
                              <!-- A custom Type column -->
                              <template #cell(folder)="element">
                                <td
                                  v-if="element.item.hasOwnProperty('req') && element.item.req.s_type_bien && element.item.req.s_usage_bien"
                                  class="title-width">
                                  {{
                                    demandTypeStatus(element.item.req.s_type_bien) + ' ' +
                                    useStatus(element.item.req.s_usage_bien) | truncate(51, " ...")
                                  }}
                                </td>
                                <td v-else-if="LoadingTitle">
                                  <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                                </td>
                                <td v-else class="text-muted-color ">Aucune données</td>
                              </template>
                              <template #cell(dateE)="element">
                                <td v-if="element.item.createdAt">{{ formatDate(element.item.createdAt) }}</td>
                                <td v-else class="text-muted-color">Aucune données</td>
                              </template>
                              <template #cell(dateL)="element">
                                <td v-if="element.item.validUntil">
                                  {{ formatDate(element.item.validUntil) }}
                                </td>
                                <td v-else class="text-muted-color w-auto">Aucune données</td>
                              </template>
                              <template #cell(state)="element">
                                <td>
                                  <span v-if="statusData(element.item.status, dataState)" class=" font-size-11"
                                    :class="statusData(element.item.status, dataState).class">
                                    {{ statusData(element.item.status, dataState).name }}
                                  </span>
                                  <span v-else-if="element.item.drafts && !element.item.status"
                                    class="badge bg-light font-size-11">Brouillon
                                  </span>
                                  <span v-else-if="!element.item.drafts && !element.item.status && element.item.validUntil > new Date().toLocaleDateString('en-CA')"
                                    class="badge badge-soft-info font-size-11">Envoyée
                                  </span>
                                  <span v-else-if="new Date().toLocaleDateString('en-CA') > element.item.validUntil" class="badge badge-soft-danger font-size-11">Expiré</span>
                                </td>
                              </template>
                              
                              <template #cell(action)="element">
                                <td class="w-auto">
                                  <ul class="font-size-20  mb-0 list-inline">
                                    <li class="aye-position">
                                      <a @click="redirectionPropsition(element.item.id)" size="sm">
                                        <i v-b-tooltip.hover title="Modifier"
                                          class="fas fa-eye px-2 pointer color-edit"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </td>
                              </template>
                            </b-table>
                            <div v-if="!proposalsByConnect && proposals.length === 0" class="mt-2">
                              <b-alert show variant="danger">
                                <i class="mdi mdi-block-helper me-2"></i>Vous n’avez <strong>aucun</strong> proposition
                              </b-alert>
                            </div>
                            <div v-if="proposalsByConnect" class="mt-2 mb-2">
                              <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                            </div>
                          </div>
                          <!-- Pagination -->
                          <Pagination @changePage="onPaginate($event, 2)" :page="currentPageMy" :itemsPerPage="5"
                            :listLength="proposals" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="card p-1">
                          <h4 class="card-title p-2">Les 5 dernières propositions d'autres banquiers</h4>
                          <div class="table-responsive shadow-none" v-if="!proposalsByFolders">
                            <b-table class="table mb-0 table-responsive" hover responsive="sm" :items="proposalsFolder"
                              :fields="headerTableAll" :per-page="5" :current-page="currentPage">
                              <!-- A custom Type column -->
                              <template #cell(title)="element">
                                <td v-if="element.item.poNumber" class="title-width">
                                  {{ element.item.poNumber }}
                                </td>
                                <td v-else class="text-muted-color w-auto">Aucune données</td>
                              </template>
                              <template #cell(dateP)="element">
                                <td v-if="element.item.createdAt" class="w-auto">
                                  {{ formatDate(element.item.createdAt) }}
                                </td>
                                <td v-else class="text-muted-color w-auto">Aucune données</td>
                              </template>
                            </b-table>
                            <!-- Pagination -->
                          </div>
                          <div v-if="!proposalsByFolders && proposalsFolder.length === 0" class="mt-2">
                            <b-alert show variant="danger">
                              <i class="mdi mdi-block-helper me-2"></i>Vous n’avez <strong>aucun</strong> proposition
                            </b-alert>
                          </div>
                          <div v-if="proposalsByFolders" class="mt-2 mb-2">
                            <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                          </div>
                          <!-- Pagination -->
                          <Pagination @changePage="onPaginate($event, 1)" :page="currentPage" :itemsPerPage="5"
                            :listLength="proposalsFolder" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <!--Affectation dossier-->

        <b-tab :active="!isNaN(root)"  v-if="isManager">
          <template v-slot:title>
            <i class="bx bx-user-plus d-block check-nav-icon mt-3 mb-1"></i>
            <p class="fw-bold mb-3">Affectations</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">Historiques des Affectations</h4>
                  <div class="col-xl-12 col-sm-12">
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="card p-1">
                          <table class="table table-nowrap">
                      <tbody>
                        <tr>
                          <th scope="row">Agent :</th>
                          <td v-if="hasAssignement()">{{ assignement.firstName }} {{ assignement.lastName }}</td>
                         
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr >
                          <th scope="row">Adresse e-mail :</th>
                          <td v-if="hasAssignement()">{{ assignement.email }}</td>
                          
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr >
                          <th scope="row">Agence :</th>
                          <td v-if="hasAssignement()">{{ assignement.name }}</td>
                          
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                        <tr >
                          <th scope="row">Date d'affectation :</th>
                          <td v-if="hasAssignement()">{{ formatDate(assignement.createdAt.date) }}</td>
                          
                          <td v-else class="text-muted-color">Aucune données</td>
                        </tr>
                      </tbody>
                    </table>
                      
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <!--fin affectation-->
      </b-tabs>
       <!--Modal affectaion dossier-->

  <b-modal v-model="showModal" title="Affectation du dossier" @click="showModal = true" size="lg" hide-footer >
    <b-table :items="agents" :fields="fields" striped hover>
        <template #cell(agent)="data">
          {{ data.item.firstName }} {{ data.item.lastName }} 
        </template>
        <template #cell(email)="data">
          {{ data.item.email }} 
        </template>
        <template #cell(agence)="data">
          {{ data.item.agence }} 
        </template>
        <template #cell(code)="data">
          {{ data.item.code }} 
        </template>
        <template #cell(action)="data">
          <b-button class="btn btn-success" @click="checkAndAssignAgent(data.item.id)" size="sm">Affecter</b-button>
        </template>
      </b-table>
    </b-modal>
  <!--fin modal-->
    </div>
  </Layout>
 
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import api from "../../../services/axiosHeader.js";
import { addHistory, assignAgent, checkAssignement, favoritesDossier, getAssignement, IMAGE_URL } from "../../../../api/entryPoint";
import { showAlert } from "@/state/modules/proposals";
import { dataState } from "@/router/views/proposals/statusData";
import Pagination from "@/components/pagination";
import { titlesHeaderMyProposalsModel, titlesHeaderProposalsModel } from "@/router/views/titlesHeaderModel";
import { mapGetters } from 'vuex';
/**
 * FAQs component
 */
export default {
  page: {
    title: "Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Pagination },
  data() {
    return {
      title: "Details",
      items: [],
      toEditProfile: false,
      favoris: false,
      value: 0,
      root: '',
      currentPageMy: 1,
      currentPage: 1,
      perPage: 3,
      filterKeyword: '',
      headerTable: titlesHeaderMyProposalsModel,
      headerTableAll: titlesHeaderProposalsModel,
      dataState: [],
      nowDate: '',
      showModal: false,
      oldAgent:null,
      fields: [
        { key: 'agent', label: 'Agent' },
        { key: 'email', label: 'Email' },
        { key: 'agence', label: 'Agence' },
        { key: 'code', label: 'Code' },
        { key: 'action', label: 'Affecter' },

      ],
      userRole: localStorage.getItem('roles'),
    };
  },
  mounted() {
    this.$store.dispatch("mesdoc/rating", this.$route.params.id);
    localStorage.setItem('root', this.$route.query.name);
    this.root = localStorage.getItem('root');
    this.$store.dispatch("proposals/proposalUserConnect", this.$route.params.id);
    this.$store.dispatch("proposals/proposalFolder", this.$route.params.id);
    this.dataState = dataState;
  },
  created() {
    this.getDetails();
    this.isFavoris();
    this.getAssignement();
  },
  methods: {
    openModal() {
    this.$store.dispatch('catalogs/agentsByBank')
      .then(() => {
        this.showModal = true;
      })
      .catch(error => {
        console.error("Error fetching agents:", error);
      });
  },
    // Call a function to get a folder details   by id
    getDetails() {
      this.$store.dispatch("catalogs/folderDetails", this.$route.params.id);
    },
    // generate a clean image path
    pathImage(name) {
      return IMAGE_URL + name;
    },
    // add/remove folder to/from favoris
    addToFavoris() {
      api.post(favoritesDossier + this.$route.params.id, null)
        .then((res) => {
          this.favoris = res.data;
        });
    },
    // check if current folder is in favoris
    isFavoris() {
      api.get(favoritesDossier + this.$route.params.id + "/details")
        .then((res) => {
          this.favoris = res.data;
        });
    },
    downloadFile(value) {
      var a = document.createElement("a"); //Create <a>
      a.href = `data:${value.mimeType};base64,` + value.content; //Image Base64 Goes here
      a.download = `${value.originalFilename}`; //File name Here
      a.click(); //Downloaded file
    },
    alert() {
      showAlert({
        icon: "error",
        title: "Aucune données",
        text: "Échec du téléchargement",
      });
    },
    changeNote(value) {
      this.value = value.s_rating;
    },
    redirectionPropsition(root) {
      this.$root.$router.push({
        path: '/proposals/' + root,
        query: { name: 'propFolder' }
      })
    },
    /* change page */
    onPaginate(event, id) {
      (id === 1) ? this.currentPage = event : this.currentPageMy = event;
    },
    dateCompare(str1) {
      const Datee = new Date(str1)
      const myDate = new Date();
      const jour = (3600 * 24);
      this.nowDate = Datee > myDate;
      return (Math.round(Math.floor((Datee - myDate) / jour) / 1000));
    },
    checkAndAssignAgent(agentId) {
      // Check if the dossier is already assigned
      api.get(checkAssignement+this.$route.params.id)
        .then(response => {
          
          if (response.data && response.data.length > 0) {
            const data =response.data[0];
            const agentName = data.agent;
            const agence = data.agence ;
            this.oldAgent = data.id;
            // Show confirmation alert
            this.$bvModal.msgBoxConfirm(`Ce dossier est déjà affecté à ${agentName} de l'agence ${agence} . Cette action va écraser l'ancienne affectation. Voulez-vous continuer ?`, {
              title: 'Confirmer l\'affectation',
              size: 'md',
              okTitle: 'Oui',
              cancelTitle: 'Non',
              footerClass: 'p-2',
              hideHeaderClose: false,
              centered: true
            })
            .then(value => {
              if (value) {
                // User confirmed, proceed with assignment
                this.assignAgent(agentId);
              }
            })
            .catch(err => {
              console.error(err);
            });
          } else {
            // No existing assignment, proceed with assignment
            this.assignAgent(agentId);
          }
        })
        .catch(error => {
          console.error('Error checking assignment:', error);
        });
    },
    assignAgent(agent) {
      api.post(`${assignAgent}?agent=${agent}&request=${this.$route.params.id}&oldAgent=${this.oldAgent}`)
        .then(response => {
          this.showModal = false; 
          this.getAssignement();
        })
        .catch(error => {
          console.error('Error assigning agent:', error);
        });
    },
    getAssignement() {
      this.$store.dispatch("catalogs/assignement", this.$route.params.id);
    },
    hasAssignement() {
      return this.assignement && Object.keys(this.assignement).length > 0;
    },
    addDownloadHistory(file,idfolder) {
      this.downloadFile(file);
      api.get(addHistory + idfolder ).then(response => {
        console.error('Fichier téléchargé avec succès !');
        })
        .catch(error => {
          console.error('Erreur ajout historique :', error);
        });
    }
  },
  computed: {
    ...mapGetters({
      agents: 'catalogs/getAgentsByBank',
      assignement : 'catalogs/getAssignementByBank'
    }),
    // Get folder data from store
    folder() {
      let value = this.$store.getters["catalogs/getDetails"];
      this.changeNote(value)
      console.log(value);
      return value;
    },
    loadingDetails() {
      return this.$store.getters["catalogs/getIsLoadingDetails"];
    },
    note() {
      let value = this.$store.getters["mesdoc/getRating"];
      this.changeNote(value)
      return value;
    },
    // Get proposals user connect data from store
    proposals() {
      return this.$store.getters["proposals/getListPropsUser"];
    },
    // Get proposals folder data from store
    proposalsFolder() {
      return this.$store.getters["proposals/getListPropsFolder"];
    },
    proposalsByFolders() {
      return this.$store.getters["proposals/getIsLoadingFolders"];
    },
    proposalsByConnect() {
      return this.$store.getters["proposals/getIsLoadingConnect"];
    },
    rows() {
      return this.proposalsFolder.length;
    },
    LoadingTitle() {
      return this.$store.getters["proposals/getIsLoadingTitle"];
    },
    isManager() {
      return this.userRole.includes('ROLE_MANAGER');
    }
    
  },
  filters: {
    truncateMontant: function (text) {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(text)
    },
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
};
</script>


<style scoped lang="scss">
.icon-hover:hover {
  border-radius: 16px;
  color: #FFFFFF;
  background: #036183 0 0 no-repeat padding-box;
  width: 36px;
  height: 34px;
}

.bx {
  font-size: xx-large;
}

.style-text .table-nowrap th,
.table-nowrap td {
  white-space: unset !important;
  text-align: justify;
}

::v-deep span.b-rating-star.b-rating-star-empty svg {
  fill: #74788d;
}

.style-rating .form-control {
  display: flex !important;
  width: 100%;
  line-height: 1.5;
  background-color: unset;
  background-clip: unset;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid #EFF2F7;
  border-radius: 4px;
  vertical-align: baseline;
}

a.router-link-active h4:hover {
  color: #1F84D2;
}

.title-width {
  width: 36% !important;
}

.ml-6 {
  margin-left: 4px !important;
}

.aye-position {
  display: flex;
}

.card {
  -webkit-box-shadow: none;
}

::v-deep .box-size.checkout-tabs .nav-pills .nav-link {
  margin-bottom: 12px;
  box-shadow: none !important;
}

::v-deep thead {
  color: #000000;
  border-color: #eff2f7;
  background-color: #eff2f7;
}

.card {
  height: 98% !important;
}

.tab-content>.active {
  height: 100% !important;
}

.card-text:last-child {
  height: 100%;
}

th {
  width: 15px !important;
}

.return-size {
  width: 5%;
}

.positionner {
  line-height: 33px !important;
  margin-left: 20px;
  font-style: italic;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
</style>